<template>
  <div>
    <slot>
      <a href="#" @click.prevent="$bvModal.show(id)" class="text-dark">{{ value || "-" }}</a>
    </slot>
    <b-modal :id="id" size="sm" title="Editar campo" :ok-disabled="loading || newValue === ''" @ok="handleOk">
      <b-form-group :label="getFieldLabel(field)">
        <b-form-input
          v-model="newValue"
          :placeholder="'Ingrese ' + getFieldLabel(field)"
          :disabled="loading"
          @keyup.enter="handleOk"
          v-if="inputOptions.length === 0"
        ></b-form-input>
        <b-form-select
          v-model="newValue"
          :placeholder="'Seleccione ' + getFieldLabel(field)"
          :disabled="loading"
          :options="inputOptions"
          value-field="label"
          text-field="label"
          @change="updateCertificate"
          v-else
        >
        </b-form-select>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ModalUpdateCertificates",
  data() {
    return {
      newValue: this.value || "",
      loading: false
    };
  },
  props: {
    id: {
      type: String | Number,
      default: 0
    },
    field: {
      type: String
    },
    value: [String, Number],
    inputType: {
      type: String,
      default: "text"
    },
    headings: {
      type: Array
    },
    data: {
      type: Object
    },
    inputOptions: {
      type: Array
    }
  },
  methods: {
    getFieldLabel(field) {
      return this.headings.find((h) => h.key === field).label;
    },
    handleOk(bvModalEvent) {
      if (this.newValue === this.value) {
        return;
      } else {
        bvModalEvent.preventDefault();
        this.updateCertificate();
      }
    },
    getOptionColor(key, option) {
      const fieldObj = this.headings.find((f) => f.key === key);
      if (fieldObj) {
        const optionObj = fieldObj.inputOptions.find((o) => o.label === option);
        if (optionObj) {
          return optionObj.color;
        }
      }
      return "";
    },
    async updateCertificate() {
      this.loading = true;
      try {
        const value = `${this.field}:${this.newValue}`;
        let newCertificates = this.data.certificates;
        // Remove existing certificate that starts with the same field
        newCertificates = newCertificates.filter((c) => !c.startsWith(this.field));
        // Add new certificate
        newCertificates.push(value);

        const response = await this.$axios.put(`/api/v1/origin/${this.data.id}/update_certificates/`, {
          value: newCertificates
        });
        const itemCertificates = response.data.certificates.map((item) => ({
          key: item.split(":")[0],
          value: item.split(":")[1]
        }));
        let newItem = response.data;
        newItem["_cellVariants"] = {};
        for (let i = 0; i < itemCertificates.length; i++) {
          newItem[itemCertificates[i].key] = itemCertificates[i].value;
          newItem["_cellVariants"] = {
            ...newItem["_cellVariants"],
            [itemCertificates[i].key]: this.getOptionColor(itemCertificates[i].key, itemCertificates[i].value)
          };
        }
        this.$emit("update", newItem);
        this.$nextTick(() => {
          this.$bvModal.hide(this.id);
        });
      } catch (error) {
        this.$bvToast.toast("Error al actualizar huerto", {
          title: "Error",
          variant: "danger",
          solid: true
        });
        console.log(error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style></style>
